import { render } from "./AddAreaEco.vue?vue&type=template&id=22e171ae&scoped=true"
import script from "./AddAreaEco.vue?vue&type=script&lang=js"
export * from "./AddAreaEco.vue?vue&type=script&lang=js"

import "./AddAreaEco.vue?vue&type=style&index=0&id=22e171ae&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e171ae"]])

export default __exports__